import { useState } from "react";
import createAxiosInstanceNew from "../Api/AxiosInstance/AxiosInstance";

export default function usePost() {
  const initialState = {
    data: null,
    loading: false,
    error: "",
    message: "",
    success: null,
  };
  const [response, setResponse] = useState(initialState);

  async function post(
    endPoint,
    data,
    headers = {
      "Content-Type": "application/json",
    }
  ) {
    try {
      const axiosInstance = await createAxiosInstanceNew();

      setResponse({
        ...response,
        loading: true,
      });

      const res = await axiosInstance.post(`${endPoint}`, data, {
        headers: headers,
      });

      if (res.data.statusCode === 200 || res.status === 200) {
        setResponse((prev) => ({
          ...prev,
          data: res.data,
          loading: false,
          error: "",
          message: res.data.message,
          success: true,
        }));
      }
      // else {
      //   setResponse((prev) => ({
      //     ...prev,
      //     data: null,
      //     loading: false,
      //     error: res.data.message,
      //     message: "",
      //     success: false,
      //   }));
      // }
    } catch (error) {
      setResponse((prev) => ({
        ...prev,
        data: null,
        loading: false,
        error: error.response.data.message,
        message: "",
        success: false,
      }));
    } finally {
      setResponse((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  }

  function reset() {
    setResponse(initialState);
  }

  return {
    post,
    success: response.success,
    setResponse,
    reset,
    loading: response.loading,
    error: response.error,
  };
}
